import { Injectable } from '@angular/core';

export interface ErrorCodeMap {
  [key: number]: string;
}

export interface ErrorResult {
  message: string;
  params?: any;
  code?: number;
}

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {

  getErrorMessage(error: any, errorCodeMap?: ErrorCodeMap): ErrorResult {
    const defaultError: ErrorResult = { message: 'errors.generic.message' };
    
    if (!error) return defaultError;

    const firstError = this.extractFirstError(error);
    
    if (firstError?.code && errorCodeMap?.[firstError.code]) {
      return {
        message: errorCodeMap[firstError.code],
        code: firstError.code,
        params: firstError.value ? { value: firstError.value } : undefined
      };
    }

    return {
      message: error?.error?.message || error?.message || 'errors.generic.message',
      code: firstError?.code
    };
  }

  getErrorCode(error: any): number | null {
    return this.extractFirstError(error)?.code || null;
  }

  private extractFirstError(error: any): { code?: number; value?: string } | null {
    if (error?.errors?.[0]) return error.errors[0];
    if (error?.error?.errors?.[0]) return error.error.errors[0];
    return null;
  }
}
